import { CaretDownOutlined, UploadOutlined } from "@ant-design/icons"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
  Upload,
} from "antd"
import axios from 'axios'
import React, { memo, useState } from "react"
import { emails } from "../data"
import "../styles/infoModal.scss"
import { getBase64 } from "./../utils/utils"

const topicToResource = {
  rjs: "Senior React.js Frontend Developer",
  drd: "Microsoft Dynamics 365 F&O Developer",
  ned: "Senior .NET / C# Backend Developer",
  fed: "Flutter Mobile App Developer",
  oed: "Odoo ERP Developer & Consultant",
  aie: "AI / ML Engineer",
}

const LetUsKnowRequirements = ({
  url,
  companyIsEnabled,
  isModalVisible,
  handleOk,
  handleCancel,
  location,
}) => {
  const topicKey = location?.search?.split("=")[1]
  const preselectedResource = topicToResource[topicKey]

  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([])
  const [loading, setLoading] = useState(false)
  // const { executeRecaptcha } = useGoogleReCaptcha();
  // useEffect(() => {
  //   const getToken = async () => {
  //     if (!executeRecaptcha) return;
  //     const token = await executeRecaptcha("staff_augmentation");
  //     // Verify with server
  //     const res = await fetch("https://staging.visiomate.com/verify-recaptcha-site", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ token }),
  //     });

  //     const data = await res.json();
  //     setIsVerified(data.success && data.score > 0.5);
  //     // setIsVerified(data.success);
  //   }
  //   getToken();
  // }, [executeRecaptcha])
  const { TextArea } = Input

  const handleChange = (value) => {
  };

  const normFile = e => {
    if (!fileList?.length) {
      return []
    }
    return Array.isArray(e) ? e : e && e.fileList
  }

  const handleFormData = async values => {
    const {
      firstName,
      lastName,
      email,
      phone,
      projectDetails: rawProjectDetails,
      company,
      country,
      numberOfEmployees,
      file,
      TypeOfResourcesRequired
    } = values;

    const name = `${firstName} ${lastName}`;
    const budget = undefined;
    const projectDetails = [
      rawProjectDetails,
      country ? `Country: ${country}` : null,
      numberOfEmployees ? `No. of Employees: ${numberOfEmployees}` : null,
    ].filter(Boolean).join('\n\n');

    let attachment_base64 = null;

    if (file && file[0] && file[0].originFileObj) {
      attachment_base64 = await getBase64(file[0].originFileObj);
    }

    const formData = {
      name: "Staff Augmentation: " + name + " | " + TypeOfResourcesRequired,
      partner_name: company,
      email_from: email,
      phone,
      mobile: phone,
      description: projectDetails,
      attachment_base64,
      email_to: emails.info,
      budget,
    };

    sendFormData(formData);
  };
  const sendFormData = async (data) => {
    try {

      await axios.post('https://staging.visiomate.com/crmPipeline', data);
      form.resetFields()
      message.success('Application submitted successfully!');
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      message.error('Failed to submit application. Please try again later.');
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const onFinish = values => {
    setLoading(true);
    handleFormData(values)
  }

  const uploadProps = {
    fileList,
    accept: ".png, .jpg, .jpeg, .pdf, .doc, .docx,",
    maxCount: 1,
    onRemove: file => {
      setFileList([])
    },
    beforeUpload: file => {
      const isLt200Kb = file.size / 1024 < 200;
      if (!isLt200Kb) {
        message.error("File must be smaller than 200kb!")
        setFileList([])
        return;
      }
      setFileList([file])
      return false
    },
  }

  return (
    <div className="LetUsKnowRequirements">
      <Form
        form={form}
        name="about"
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        initialValues={{ TypeOfResourcesRequired: preselectedResource }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[{ required: true, message: "Please input your First Name!" }]}
            >
              <Input placeholder="" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[{ required: true, message: "Please input your Last Name!" }]}
            >
              <Input placeholder="" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please input your Email!" }]}
            >
              <Input placeholder="" type="email" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Phone number (optional)"
              name="phone"
              rules={[
                { required: false },
                {
                  pattern: /^\+[1-9]\d{6,14}$/,
                  message: 'Enter a valid international number (e.g. +923001234567)',
                },
              ]}
            >
              <Input placeholder="+1 234 567 8900" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Company"
              name="company"
              rules={[{ required: true, message: "Please enter your Company name!" }]}
            >
              <Input placeholder="" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Country"
              name="country"
              rules={[{ required: true, message: "Please select your Country!" }]}
            >
              <Select
                placeholder="Select Country"
                showSearch
                optionFilterProp="label"
                suffixIcon={<CaretDownOutlined className="CaretDownOutlined" />}
                options={[
                  { label: "United States", value: "United States" },
                  { label: "United Kingdom", value: "United Kingdom" },
                  { label: "Canada", value: "Canada" },
                  { label: "Australia", value: "Australia" },
                  { label: "Germany", value: "Germany" },
                  { label: "France", value: "France" },
                  { label: "Netherlands", value: "Netherlands" },
                  { label: "Sweden", value: "Sweden" },
                  { label: "Norway", value: "Norway" },
                  { label: "Denmark", value: "Denmark" },
                  { label: "Switzerland", value: "Switzerland" },
                  { label: "UAE", value: "UAE" },
                  { label: "Saudi Arabia", value: "Saudi Arabia" },
                  { label: "Qatar", value: "Qatar" },
                  { label: "Kuwait", value: "Kuwait" },
                  { label: "Bahrain", value: "Bahrain" },
                  { label: "Oman", value: "Oman" },
                  { label: "Pakistan", value: "Pakistan" },
                  { label: "India", value: "India" },
                  { label: "Other", value: "Other" },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="No. of Employees"
              name="numberOfEmployees"
              rules={[{ required: true, message: "Please select company size!" }]}
            >
              <Select
                placeholder="Select company size"
                suffixIcon={<CaretDownOutlined className="CaretDownOutlined" />}
                options={[
                  { label: "1–10", value: "1–10" },
                  { label: "11–50", value: "11–50" },
                  { label: "51–200", value: "51–200" },
                  { label: "201–500", value: "201–500" },
                  { label: "500+", value: "500+" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Type of Resources Required"
              name="TypeOfResourcesRequired"
              rules={[{ required: true, message: "Please select Resources Required!" }]}
            >
              <Select
                placeholder="Select type of resource"
                onChange={handleChange}
                suffixIcon={<CaretDownOutlined className="CaretDownOutlined" />}
                options={[
                  { label: "Senior React.js Frontend Developer", value: "Senior React.js Frontend Developer" },
                  { label: "Microsoft Dynamics 365 F&O Developer", value: "Microsoft Dynamics 365 F&O Developer" },
                  { label: "Senior .NET / C# Backend Developer", value: "Senior .NET / C# Backend Developer" },
                  { label: "Flutter Mobile App Developer", value: "Flutter Mobile App Developer" },
                  { label: "Odoo ERP Developer & Consultant", value: "Odoo ERP Developer & Consultant" },
                  { label: "AI / ML Engineer", value: "AI / ML Engineer" },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="What problem you are trying to solve with this augmentation?"
          name="projectDetails"
          rules={[{ required: true, message: "Please describe what you are trying to solve!" }]}
          style={{ marginBottom: "0" }}
        >
          <TextArea
            placeholder=""
            maxLength={250}
            autoSize={{ minRows: 4, maxRows: 4 }}
          />
        </Form.Item>
        <p style={{ textAlign: "end", marginBottom: "0" }}>250 Characters</p>
        <Form.Item
          label=""
          name="file"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={[{ required: false }]}
          style={{ marginBottom: "0" }}
        >
          <Upload accept=".doc,.docx,.xml,.pdf" {...uploadProps}>
            <Button icon={<UploadOutlined />}>Attach a file</Button>
          </Upload>
        </Form.Item>
        <span className="file-limit-info">Max. size 200KB</span>
        {/* <ReCAPTCHA
          sitekey="6Le4Xc4pAAAAACdoP1-v8vNKtHOYfkJiXrOBvi8V"
          onChange={onCaptchaChange}
          style={{ marginTop: "1rem" }}
        /> */}
        <Form.Item>
          <Button
            className="button"
            style={{ borderRadius: "5px" }}
            type="primary"
            htmlType="submit"
          // disabled={captchaValue === null}
          >
            {loading ? <Spin /> : "Send"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
export default memo(LetUsKnowRequirements)
